var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('canvas',{ref:"my-canvas",attrs:{"height":_vm.height,"width":_vm.width,"id":"my-canvas"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }